import { formatDateWithTimeAMPM } from "@/shared"
import { IBras } from "@/shared/interfaces/erp/configuracion-red/bras/bras.interface"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

export const useTableColumnsBras = () => {

  const columnsBras = useMemo<MRT_ColumnDef<IBras>[]>(() => [
    {
      accessorKey: 'nombre',
      header: 'Nombre',
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
    },
    {
      accessorKey: 'direccion',
      header: 'direccion',
    },
    {
      accessorKey: 'coordenadas',
      header: 'coordenadas',
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'fecha_creacion',
      Cell({ row }) {
        return formatDateWithTimeAMPM(row.original.fecha_creacion||"")
      },
    },
    {
      accessorKey: 'pais',
      header: 'pais',
    },
    {
      accessorKey: 'provincia',
      header: 'provincia',
    },
    {
      accessorKey: 'ciudad',
      header: 'ciudad',
    },
    {
      accessorKey: 'zona',
      header: 'zona',
    },
    {
      accessorKey: 'sector',
      header: 'sector',
    },
  ], [])

  return {
    columnsBras
  }
}